import fetch from "./fetch";
/**
 * 评论管理
 */
const comment = {
  //获取评论
  getComment(params) {
    return fetch({
      isLoading: true,
      url: "/v1/Comment/comment",
      method: "GET",
      params
    });
  },
  // 更改评论状态
  changeCommentStatus(data) {
    return fetch({
      isLoading: true,
      url: "/v1/Comment/shield",
      method: "POST",
      data
    });
  },


};

export default comment;
